import { createActions, createReducer } from 'reduxsauce'

import DespesasMensaisPorFornecedorService from '../../servicos/DespesasMensaisPorFornecedorService '

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDespesasMensaisPorFornecedorInicio: [],
    buscaDespesasMensaisPorFornecedorSucesso: ['despesasMensaisPorFornecedor'],
    buscaDespesasMensaisPorFornecedorErro: ['erro'],
    setDespesasMensaisPorFornecedorEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaDespesasMensaisPorFornecedor = data => {
    return dispatch => {
        dispatch(Creators.buscaDespesasMensaisPorFornecedorInicio())
        let serv = new DespesasMensaisPorFornecedorService()
        serv.consultar(data)
            .then(response => dispatch(Creators.buscaDespesasMensaisPorFornecedorSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDespesasMensaisPorFornecedorErro(error)))
    }
}

const buscaDespesasMensaisPorFornecedorInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaDespesasMensaisPorFornecedorErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro })

const buscaDespesasMensaisPorFornecedorSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.despesasMensaisPorFornecedor.resultado,
        dataSincronizacaoDados: action.despesasMensaisPorFornecedor.dataSincronizacaoDados,
        carregando: false,
    }
}

const setDespesasMensaisPorFornecedorEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DESPESAS_MENSAIS_POR_FORNECEDOR_INICIO]: buscaDespesasMensaisPorFornecedorInicio,
    [Types.BUSCA_DESPESAS_MENSAIS_POR_FORNECEDOR_ERRO]: buscaDespesasMensaisPorFornecedorErro,
    [Types.BUSCA_DESPESAS_MENSAIS_POR_FORNECEDOR_SUCESSO]: buscaDespesasMensaisPorFornecedorSucesso,
    [Types.SET_DESPESAS_MENSAIS_POR_FORNECEDOR_ESTADO_DT]: setDespesasMensaisPorFornecedorEstadoDT,
})
